import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {MemberService} from '../services/member.service';
import {MemberModel} from '../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class InnerGuard {

    constructor(
        protected memberService: MemberService,
        protected router: Router
    ) {
    }

    async canActivate(): Promise<boolean> {
        const member: MemberModel = await this.memberService.getCurrentMember(true) as MemberModel;
        if (member) {
            if (member.project_setting.is_project_admin || member.project_setting.observation_type === 'dep_admin') {
                return true;
            }
            return member.project_setting.observation_type === 'inner';
        }

        return false;
    }

}
